import { Component, HostListener, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-sidebar',
  templateUrl: './nav-sidebar.component.html',
  styleUrls: ['./nav-sidebar.component.scss']
})
export class NavSidebarComponent implements OnInit {

  is_close_sidebar_menu: boolean = false;
  constructor() { }

  ngOnInit(): void {
    this.changeSize();
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.changeSize();
  }

  changeSize() {
    const innerWidth = window.innerWidth;
    if (innerWidth < 868) {
      this.is_close_sidebar_menu = true;
    }
  }

}
